import { render, staticRenderFns } from "./Playbokgi.vue?vue&type=template&id=558e7c66&"
import script from "./Playbokgi.vue?vue&type=script&lang=js&"
export * from "./Playbokgi.vue?vue&type=script&lang=js&"
import style0 from "./Playbokgi.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports